import { render } from "./InspectionComparison.vue?vue&type=template&id=4815af55"
import script from "./InspectionComparison.vue?vue&type=script&lang=js"
export * from "./InspectionComparison.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__